import styled from 'styled-components';

export default styled.div`
  width: 100%;
  display: flex;
  column-gap: 8px;
  align-items: center;

`;
